<template>
  <div>
    <b-modal
      size="md"
      hide-header-close
      no-close-on-backdrop
      hide-footer
      :id="`delete-category-${data.id}`"
      title="EXCLUIR CATEGORIA"
    >
      <div class="row">
        <ReleasesDelete
          type="finance_configuration_category"
          :id="data.id"
          @total="handleVerifyReleasesToDelete"
        />
        <div class="col-md-12" v-if="totalReleases > 0">
          Há {{ totalReleases }} lançamento(s) cadastrado(s) nesta categoria. O
          que deseja fazer?
        </div>
        <div class="col-md-12" v-if="totalReleases > 0">
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_only_delete"
              value="type_only_delete"
            />
            <label class="form-check-label" for="type_only_delete"
              >Deixar todos os lançamentos sem categoria</label
            >
          </div>
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_delete_transfer"
              value="type_delete_transfer"
            />
            <label class="form-check-label" for="type_delete_transfer"
              >Transferir lançamentos para outra categoria</label
            >
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="totalReleases > 0 && type_delete == 'type_delete_transfer'"
        >
          <treeselect
            :options="finance_configuration_category"
            placeholder="SELECIONE..."
            v-model="transfer_id"
            noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
          />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errorsDelete" />
        </div>
        <div class="col-md-6">
          <v-btn
            @click="$bvModal.hide(`delete-category-${data.id}`)"
            class="btn-cancel"
          >
            <i class="fas fa-times mr-2 text-twenty"></i>
            CANCELAR
          </v-btn>
        </div>
        <div class="col-md-6 text-right">
          <v-btn :disabled="loading" @click="handleDelete" class="btn-delete">
            <i class="fas fa-check mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "EXCLUIR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-8">
        <label>Nome</label>
        <input type="text" class="form-control" v-model="name" />
      </div>
      <div class="col-md-4">
        <label>Cor</label>
        <input type="color" class="form-control" v-model="color" />
      </div>
      <div v-if="data.default == 0" class="col-md-12">
        <label>Tipo de categoria</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="parent"
              value="parent"
            />
            <label class="form-check-label" for="parent">Categoria pai</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="daughter"
              value="daughter"
            />
            <label class="form-check-label" for="daughter"
              >Categoria filha</label
            >
          </div>
        </div>
      </div>
      <div v-if="type == 'daughter'" class="col-md-6">
        <label>Categoria pai</label>
        <!-- <select
          v-model="parent_id"
          class="form-control"
          @change="handleSelectParentCategoryId"
        >
          <option v-for="(item, key) in parents" :value="item.id" :key="key">
            {{ item.name }}
          </option>
        </select> -->
        <treeselect
          :options="parents"
          placeholder="SELECIONE..."
          v-model="parent_id"
          noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
          @change="handleSelectParentCategoryId"
        />
        <small v-if="parents.length == 0"
          >Não possui categoria pai cadastrado!</small
        >
      </div>
      <div v-if="data.default == 0" class="col-md-6">
        <label>Classificação</label>
        <div>
          <v-btn
            :class="[classification == 'MISTA' && 'v-dark']"
            @click="handleClickClassification('MISTA')"
            >MISTA</v-btn
          >
          <v-btn
            :class="[classification == 'DESPESA' && 'v-dark']"
            @click="handleClickClassification('DESPESA')"
            >DESPESA</v-btn
          >
          <v-btn
            :class="[classification == 'RECEITA' && 'v-dark']"
            @click="handleClickClassification('RECEITA')"
            >RECEITA</v-btn
          >
        </div>
      </div>
      <div v-if="data.default == 0" class="col-md-6">
        <label>Status</label>
        <select v-model="status" class="form-control">
          <option value="1">ATIVO</option>
          <option value="0">INATIVO</option>
        </select>
        <small
          >Apenas categorias ativas poderão ser utilizadas nos
          lançamentos!</small
        >
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn
          v-if="data.default == 0 && permission('remove', 'financial_category')"
          class="btn-delete mr-1"
          @click="deleteCategory"
        >
          <i class="fas fa-trash mr-2"></i>
          EXCLUIR</v-btn
        >
        <v-btn
          v-if="permission('edit', 'financial_category')"
          :disabled="loading"
          @click="update"
          class="btn-save"
        >
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import Treeselect from "@riophae/vue-treeselect";

import ReleasesDelete from "../Delete/releases.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import permission from "../../../../lib/permission";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    Treeselect,
    ReleasesDelete,
  },

  props: {
    data: Object,
  },

  data() {
    return {
      totalReleases: 0,
      type_delete: null,
      finance_configuration_category: [],
      transfer_id: null,
      name: "",
      color: "",
      type: "",
      classification: "",
      parent_id: "",
      status: "",
      parents: [],
      loading: false,
      errors: [],
      errorsDelete: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleInputType() {
      this.parent_id = "";
      this.classification = "";
    },

    handleClickClassification(classification) {
      let { type } = this;

      if (type == "daughter") {
        return;
      }

      this.classification = classification;
    },

    handleSelectParentCategoryId() {
      let { parent_id, parents } = this;

      let parent = parents.filter(({ id }) => id == parent_id);

      if (parent && parent.length > 0) {
        this.classification = parent[0].classification;
      }
    },

    retrieve() {
      let { data } = this;

      this.name = data.name;
      this.color = data.color;
      this.type = data.type;
      this.classification = data.classification;
      this.parent_id = data.finance_configuration_category_id;
      this.status = data.status;
      this.getParents();
      this.financeConfigurationCategory();
    },

    async financeConfigurationCategory() {
      try {
        let {
          data: { id },
        } = this;

        let params = { diff_id: id };
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          { params }
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },

    async getParents() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/configuration/category-all"
        );

        const { data } = response.data;

        let parents = data.filter(({ id }) => id != this.data.id);

        this.parents = parents;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete() {
      try {
        let {
          data: { id },
          transfer_id,
          type_delete,
        } = this;

        let data = { id, transfer_id, type_delete };

        const response = await api.delete(
          "/rest-home/financial/configuration/category",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-${this.data.id}`);

          this.$emit("success");
          this.errorsDelete = [];
        } else {
          this.errorsDelete = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const { data, name, color, type, classification, parent_id, status } =
          this;

        let params = {
          id: data.id,
          name,
          color,
          type,
          classification,
          parent_id,
          status,
        };

        const response = await api.put(
          "/rest-home/financial/configuration/category",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-${this.data.id}`);

          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    deleteCategory() {
      this.$bvModal.show(`delete-category-${this.data.id}`);
    },

    handleVerifyReleasesToDelete(total) {
      this.totalReleases = total;
      if (total == 0) {
        this.type_delete = "type_only_delete";
      } else {
        this.type_delete = null;
      }
    },
  },
};
</script>
